import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Examinee } from '../../shared/models/examinee.model';
import { Questionnaire } from '../../shared/models/questionnaire.model';
import { ExamineeService } from '../../services/examinee.service';

@Component({
  selector: 'app-assessment-auth',
  templateUrl: './assessment-auth.component.html',
  styleUrl: './assessment-auth.component.scss'
})
export class AssessmentAuthComponent {

	logo = './../../../assets/images/logo/logo-dark-wide.png';

	loading = false;
	internal_loading = false;
	eula_checked = false;
	submitted = false;
	spinner = false;

	eula_submitted = false;
	
	examinee!: Examinee;
	questionnaire!: Questionnaire;

	constructor(private translate: TranslateService, private examineeService: ExamineeService) {}

	ngOnInit(): void {
		this.loading = true;
		this.examinee = this.examineeService.examineeValue;
		this.questionnaire = this.examineeService.questionnaireValue;

		if (this.questionnaire.lang_code === 'he') {
			this.translate.use('he');
		}

		this.loading = false;
	}

	eula_submit() {
		this.submitted = true;

		if (this.eula_checked) {
			this.internal_loading = true;

			this.examineeService.sendVerifyTwoFA().subscribe({
				next: () => {
					setTimeout(() => {
						this.internal_loading = false;
						this.eula_submitted = true;
					}, 2000);
				},
				error: (err: any) => {
					this.examineeService.toastErrorMessage(err, 'Sending 2FA Code');
				}
			});
		}
	}

	onCheckedDone() {
		this.eula_checked = !this.eula_checked;
	}
}
